import { useEffect, useState } from 'react';
import { ChevronRightIcon } from '../transcription/TranscriptionIcons';
import { pickNativeAd } from './nativeAds';
import './NativeAd.css';

// Les classes i rutes eviten noms com `native-ad` o `/ads/`: els filtres
// genèrics d'EasyList amaguen aquests elements encara que siguin anuncis propis.
function trackAdEvent(name, ad) {
  if (typeof window.gtag === 'function') {
    window.gtag('event', name, { ad_id: ad.id });
  }
}

export default function NativeAd({ ads }) {
  const [ad] = useState(() => pickNativeAd(ads));

  useEffect(() => {
    if (ad) trackAdEvent('native_ad_impression', ad);
  }, [ad]);

  if (!ad) return null;

  return (
    <aside className="progress-suggestion">
      <a
        className="progress-suggestion-card"
        href={ad.href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackAdEvent('native_ad_click', ad)}
      >
        <img className="progress-suggestion-image" src={ad.image} alt={ad.imageAlt} width="96" height="128" />
        <span className="progress-suggestion-content">
          <strong className="progress-suggestion-headline">{ad.headline}</strong>
          <span className="progress-suggestion-body">{ad.body}</span>
          <span className="progress-suggestion-footer">
            <span className="progress-suggestion-cta">{ad.cta} <ChevronRightIcon /></span>
            <span className="progress-suggestion-url">{ad.displayUrl}</span>
          </span>
        </span>
      </a>
    </aside>
  );
}
